export interface RecordalService {
  chainable?: boolean;
  creationDate?: number;
  deleteInd?: boolean;
  id: number;
  lastModified?: number;
  serviceType?: RecordalServiceType;
  text?: string;
}

// These service types have proper sequence based on bug-36987
export enum RecordalServiceType {
  ASSIGNMENT = 'ASSIGNMENT',
  CHANGE_OF_ADDRESS = 'CHANGE_OF_ADDRESS',
  CHANGE_OF_NAME = 'CHANGE_OF_NAME',
  MERGER = 'MERGER',
  APPLICATION_TO_RECTIFY = 'APPLICATION_TO_RECTIFY',
  ASSIGNMENT_OF_A_LICENSE = 'ASSIGNMENT_OF_A_LICENSE',
  ASSIGNMENT_OF_A_SECURITY_INTEREST = 'ASSIGNMENT_OF_A_SECURITY_INTEREST',
  CHANGE_OF_NAMES_AND_ADDRESS = 'CHANGE_OF_NAMES_AND_ADDRESS',
  DECLARATION_OF_INVALIDITY = 'DECLARATION_OF_INVALIDITY',
  NOTICE_TO_SURRENDER_PARTIALLY_SURRENDER_A_REGISTRATION = 'NOTICE_TO_SURRENDER_PARTIALLY_SURRENDER_A_REGISTRATION',
  RECORD_PARTIAL_ASSIGNMENT_OF_GOODS_AND_SERVICES = 'RECORD_PARTIAL_ASSIGNMENT_OF_GOODS_AND_SERVICES',
  REMOVAL_OF_A_LICENSE = 'REMOVAL_OF_A_LICENSE',
  REMOVAL_OF_SECURITY_INTEREST = 'REMOVAL_OF_SECURITY_INTEREST',
}
